import Lottie from 'react-lottie-player/dist/LottiePlayerLight';
import animationData from './LungSpinner.json';

interface LungSpinnerProps {
  size?: 'md' | 'lg';
}

export function LungSpinner({ size = 'md' }: LungSpinnerProps) {
  return <Lottie play loop animationData={animationData} style={{ width: size === 'lg' ? 160 : 64 }} />;
}
